import SERVER from "./server.js";
import UI from "./ui.js";

const EVENTS = {
    SERVER,
    UI
};

export default EVENTS;
